import { useContext } from 'react'

import { WizardContext, WizardCtx } from 'src/components/data/providers/WizardProvider'

const useWizard = (): WizardCtx => useContext(WizardContext)

export default useWizard
